<template>
  <footer>
    <div class="logo-text"></div>
    <p class="registry">© ООО Грейсис, 2020</p>
    <div class="go-up">
      <p>Наверх</p>
      <div class="arrow-up"></div>
    </div>
    <div class="conf-but">
      <router-link to="privacy" class="active">Политика обработки персональных данных<br>
        Соглашение об использовании сайта</router-link>
    </div>
    <div class="sm-w">
      <div class="social-media">
        <!-- <a href="https://www.facebook.com"><div class="social-item item1 active"></div></a>
        <a href="https://www.vk.com"><div class="social-item item2 active"></div></a>
        <a href="https://www.instagram.com"><div class="social-item item3 active"></div></a>
        <a href="https://www.telegram.com"><div class="social-item item4 active"></div></a> -->
      </div>
    </div>
  </footer>
</template>

<script>
import $ from "jquery";

export default {
  name: "footerComp",
  mounted() {
    $(".go-up").click(function () {
      $("html, body").animate({ scrollTop: 0 }, "slow");
    });
  },
};
</script>

<style scoped>
.logo-text {
  background-image: url("../assets/greysislogotext.svg");
  width: 13vw;
  height: 30px;
  position: absolute;
  top: 20px;
  left: 30px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.conf-but {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 300px;
  font-size: 0.6em;
  line-height: 20px;
  font-family: Montserrat-Light;
}

.registry {
  position: absolute;
  bottom: 20px;
  left: 30px;
  font-size: 0.8em;
  font-family: Montserrat-Light;
}

footer {
  position: relative;
  background-color: #282828;
  width: 100vw;
  height: 110px;
}

.social-media {
  height: 40px;
  width: 12vw;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 30px;
  display: flex;
  justify-content: space-between;
}

.social-media a {
  height: 100%;
  width: 20%;
}

.social-item {
  height: 100%;
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.item1 {
  background-image: url("../assets/facebook.svg");
}

.item2 {
  background-image: url("../assets/vk.svg");
}

.item3 {
  background-image: url("../assets/instagram.svg");
}

.item4 {
  background-image: url("../assets/telegram.svg");
}

.go-up {
  display: none;
}

@media only screen and (max-width: 900px) {
  footer {
    height: unset;
  }

  footer .logo-text {
    width: 30vw;
    padding-top: 80px;
  }

  .go-up {
    position: relative;
    margin-top: 30px;
    margin-left: calc(5vw + 10px);
    display: block;
  }

  .arrow-up {
    height: 15px;
    width: 15px;
    background-image: url("../assets/arrow.svg");
    background-position: center;
    background-size: contain;
    transform: rotate(90deg);
    vertical-align: middle;
    margin-left: 10px;
  }

  .go-up p,
  .arrow-up {
    display: inline-block;
  }

  .registry {
    padding-top: 0px;
  }

  .conf-but {
    padding-top: 30px;
    font-size: 12px;
    width: 60%;
  }

  .social-media {
    display: flex !important;
    position: relative;
    transform: translateY(0);
    width: 50vw;
    height: 30px;
    right: 0;
    margin-top: 10px;
    justify-content: space-between;
    margin-left: 40vw;
  }

  footer .logo-text,
  .registry,
  .conf-but {
    position: unset;
    transform: translateY(0);
    margin-left: calc(5vw + 10px);
  }

  .sm-w {
    padding: 20px 0;
    position: relative;
  }
}
</style>
